<p-inputGroup>
    <input pInputText type="tel" [attr.data-testid]="getDataTestId()" [formControl]="formControl" />
    <p-button
        [icon]="props.icon ?? 'fa fa-phone-alt'"
        [disabled]="!formControl?.value"
        (onClick)="startCall(formControl.value)"
    />
</p-inputGroup>
